module.exports = __webpack_public_path__ + "assets/lookforhouse.e3e01022.svg";